import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import panelDetailsStyles from "components/AdminPanel/Details/AdminPanelDetailsStyles.module.css";
import {ReadOnlyTextField} from "components/Shared/ReadOnlyTextField";
import {TitleBar} from "components/Shared/CrudComponents/TitleBar";
import {DetailsColumn, DetailsRow} from "components/Shared/CrudComponents";
import {
  GLOBAL_CONFIGURATION_WRITE,
  useAuth,
} from "context/auth";
import Sections from "../sections";
import {useErrorHandling} from "../../../context/errorHandling";
import {fetchGlobalConfig} from "../../../services";
import {useHistory} from "react-router-dom";

export function AdminPanelDetails() {
  const [config, setConfig] = useState(null);
  const {hasAnyPrivileges} = useAuth()
  const {handleError} = useErrorHandling();
  const history = useHistory()

  useEffect(() => {
    fetchGlobalConfig()
      .then(setConfig)
      .catch((error) => handleError(error));
  }, [setConfig, handleError]);

  const {t} = useTranslation();

  const editData = () => {
    history.push('/admin-panel/edit')
  };

  const title = t("adminPanel.details.title");
  return (
    <div>
      <TitleBar
        buttonLabel={t("common.edit")}
        title={title}
        onButtonClick={editData}
        renderTitle={(title) => (
          <div className={panelDetailsStyles.title}>
            <h1>{title}</h1>
          </div>
        )}
        isButtonDisabled={!hasAnyPrivileges([GLOBAL_CONFIGURATION_WRITE])}
      />
      {config && (
        <DetailsRow>
          <DetailsColumn section={Sections.Orders}>
            <small className={"pb-1"}>
              {t("adminPanel.details.verificationValidAfterDischarge.desc")}
            </small>
            <ReadOnlyTextField
              clearDisabled
              label={"adminPanel.details.verificationValidAfterDischarge.label"}
              value={config.carrierVerificationValidityAfterDischarge}
            />
          </DetailsColumn>
          {/*Info: as for now row has to have at least 2 children. This is temp solution*/}
          <DetailsColumn section={Sections.Dummy} visible={false}/>
        </DetailsRow>
      )}
      {config && (
        <DetailsRow>
          <DetailsColumn section={Sections.CarrierEmails}>
            <small className={"pb-1"}>
              {t("adminPanel.details.carrierEmailsNumber.desc")}
            </small>
            <ReadOnlyTextField
              clearDisabled
              label={"adminPanel.details.carrierEmailsNumber.label"}
              value={config.carrierEmailsNumber}
            />
          </DetailsColumn>
          {/*Info: as for now row has to have at least 2 children. This is temp solution*/}
          <DetailsColumn section={Sections.Dummy} visible={false}/>
        </DetailsRow>

      )}
    </div>
  );
}
